import { render, staticRenderFns } from "./DetailsPlace.vue?vue&type=template&id=7dd4b477&scoped=true"
import script from "./DetailsPlace.vue?vue&type=script&lang=js"
export * from "./DetailsPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd4b477",
  null
  
)

export default component.exports